import * as R from 'ramda'
import { t } from 'ttag'

export const divmod = (a, b) => [Math.floor(a / b), a % b]
export const padNumber = digits => number =>
  Number(number)
    .toString()
    .padStart(digits, '0')

const numberOf = (singular, plural = `${singular}er`) => n =>
  n === 1 ? `${n} ${singular}` : `${n} ${plural}`

export const formatTimeVerbose = totalSeconds => {
  const [minutes, seconds] = divmod((totalSeconds || 0).toFixed(), 60)
  const mm = numberOf(t`minute`, t`minutes`)(minutes)
  const ss = numberOf(t`second`, t`seconds`)(seconds)
  if (minutes && seconds) return `${mm} and ${ss}`
  if (minutes) return mm
  if (seconds) return ss
  return t`no time`
}

export const formatTimer = totalSeconds => {
  return divmod((totalSeconds || 0).toFixed(), 60)
    .map(padNumber(2))
    .join(':')
}

export const formatProgress = (a, b) => `${a}/${b}`
export const formatPercent = (a, b) =>
  b ? `${((100 * a) / b).toFixed(0)}%` : '0%'

export const formatFileSize = (bytes, si = true, precision = 1) => {
  const units = ['', si ? 'k' : 'K', ...'MGTPEZY']
  const k = Math.min(
    Math.floor(bytes && Math.log(bytes) / Math.log(si ? 1000 : 1024)),
    units.length - 1,
  )
  const unit = k ? units[k] + (si ? 'B' : 'iB') : 'B'
  const number = k
    ? (bytes / Math.pow(si ? 1000 : 1024, k)).toFixed(precision)
    : bytes
  return `${number} ${unit}`
}

export const capitalizeFirstLetter = val =>
  val.charAt(0).toUpperCase() + val.slice(1)

export const titleCase = R.replace(/^.|\s\S/g, R.toUpper)
export const sentenceCase = R.replace(/\b\w/, R.toUpper)

export const bankersRound = val =>
  // rounds fraction of 0.5 towards even integer
  // use this instead of ordinary Math.round, to emulate python's `round()`
  Math.abs(val % 1) === 0.5 ? ((val + 0.5) >> 1) * 2 : Math.round(val)

export const percentScore = (score, fallback = '–') =>
  // round float score to percent
  R.ifElse(
    R.either(isNaN, R.isNil),
    R.always(fallback),
    R.pipe(
      R.multiply(100),
      bankersRound,
    ),
  )(score)
